import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService, GlobalService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { BaseContentService } from './base-content-service';
import { StepsData } from './def/steps-data';
import { map } from 'rxjs/operators';
import { GlobalVariablesService } from '@tmhcc-ng-lib/data-service';
import { ProductType } from '@tmhcc-ng-lib/models';

@Injectable({
  providedIn: 'root'
})
export class StepsContentService extends BaseContentService<StepsData> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    private globalService: GlobalService
  ) {
    super(http, configService, StepsContentService.staticSteps);
  }

  get data$(): Observable<StepsData> {
    if (!this.loaded) {
      return this.getStepsSitecoreData();
    }

    return of(this.data);
  }

  getStepsSitecoreData(): Observable<StepsData> {
    let url = `${this.serviceBaseUrl}${this.globalService.getProductNavUrl()}`;
    //return this.get<StepsData>(url);
    return this.get<StepsData>(url).cache(
      `${this.globalService.getProductNavUrl()}`
    );
  }

  private stepsMapper(data: StepsData): StepsData {
    if (!data) return;

    return data;
  }

  private static staticSteps: StepsData = {
    pageName: 'steps',
    forms: [
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      }
    ],
    grids: [
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: false,
        pageLength: null,
        searching: false,
        ordering: false,
        isCheckBoxRequired: false,
        responsive: false,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: false,
        allowPdfExport: false,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          }
        ]
      },
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: false,
        pageLength: null,
        searching: false,
        ordering: false,
        isCheckBoxRequired: false,
        responsive: false,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: false,
        allowPdfExport: false,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          }
        ]
      }
    ],
    tabLabels: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    sidemenu: [
      {
        name: '',
        iconClass: 'fa fa-code',
        active: true,
        submenu: [
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: []
          },
          {
            name: '',
            url: '',
            heading: ' ',
            image: null,
            displayItems: []
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: []
          }
        ]
      },
      {
        name: '',
        iconClass: 'fa fa-mobile',
        active: false,
        submenu: [
          {
            name: '',
            url: '',
            heading: '',
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 70,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 70,
              MediaId: '0b48101c-b6ee-49b8-93cd-ee7a3239102b',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            displayItems: []
          },
          {
            name: '',
            url: '',
            heading: '',
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 70,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 70,
              MediaId: '418136d1-dfa1-4504-ab74-439cdcfe5712',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            displayItems: []
          },
          {
            name: '',
            url: '',
            heading: '',
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 70,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 70,
              MediaId: 'f22a1749-bfb0-40e9-a89a-9aaff5819abd',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            displayItems: []
          }
        ]
      },
      {
        name: '',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {
            name: ' ',
            url: '',
            heading: '',
            image: null,
            displayItems: []
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: []
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: []
          }
        ]
      },
      {
        name: '',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              }
            ]
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: '0b48101c-b6ee-49b8-93cd-ee7a3239102b',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              },
              {
                keyText: ' ',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: '418136d1-dfa1-4504-ab74-439cdcfe5712',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: 'f22a1749-bfb0-40e9-a89a-9aaff5819abd',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              }
            ]
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: ' ',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              }
            ]
          }
        ]
      },
      {
        name: '',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              }
            ]
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: '0b48101c-b6ee-49b8-93cd-ee7a3239102b',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: '418136d1-dfa1-4504-ab74-439cdcfe5712',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: 'f22a1749-bfb0-40e9-a89a-9aaff5819abd',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              }
            ]
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              }
            ]
          }
        ]
      }
    ],
    buttons: [
      {
        keyText: ''
      },
      {
        keyText: ''
      },
      {
        keyText: ''
      },
      {
        keyText: ''
      }
    ]
  };
}
